import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { APIRequest, APIMultipartRequest } from '../../common/Common';
import { TARGET_YEAR_API } from '../../common/data';

const initialState = {
  selectedPreviousEmployment: null,

  isRender: false,
  dataList: [],
  detailDataList: [],

  reload: -1,
};

//전직장 불러오기
export const getPreviousEmploymentList = createAsyncThunk(
  'previousEmployment/getPreviousEmploymentList',
  async () => {
    //htmSeq 있으면 상세, 없으면 리스트
    const response = await APIRequest(`/${TARGET_YEAR_API}/S2`);
    return response;
  },
);

//전직장 상세리스트 불러오기
export const getPreviousEmploymentDetailList = createAsyncThunk(
  'previousEmployment/getPreviousEmploymentDetailList',
  async (param = {}) => {
    //htmSeq 있으면 상세, 없으면 리스트
    const response = await APIRequest(`/${TARGET_YEAR_API}/S2`, param);
    return response;
  },
);

//전직장 삭제
export const deletePreviousEmployment = createAsyncThunk(
  'previousEmployment/deletePreviousEmployment',
  async param => {
    const response = await APIRequest(`/${TARGET_YEAR_API}/S2Del`, param);
    return response;
  },
);

//메일, 알림톡 발송
export const S2SendLink = createAsyncThunk('previousEmployment/S2SendLink', async param => {
  const response = await APIRequest('/YA/S2SendLink', param);
  return response;
});

// 파일 업로드 (OCR 분석용)
export const uploadPreviousFile = createAsyncThunk(
  'previousEmployment/uploadPreviousFile',
  async files => {
    const formData = new FormData();
    // 단일 파일 또는 파일 배열 모두 지원
    const fileArray = Array.isArray(files) ? files : [files];
    fileArray.forEach(file => {
      formData.append('files', file);
    });
    formData.append('HtmItemType', '8');
    const response = await APIMultipartRequest('/YA/NoPaperTempFileUpload', formData);
    return response;
  },
);

// 파일 로드 (OCR 분석 결과 폴링)
export const loadPreviousFileResult = createAsyncThunk(
  'previousEmployment/loadPreviousFileResult',
  async () => {
    const response = await APIRequest('/YA/NoPaperTempFileLoad', { htmItemType: '8' });
    return response;
  },
);

// 전직장 저장
export const savePreviousEmployment = createAsyncThunk(
  'previousEmployment/savePreviousEmployment',
  async saveData => {
    const formData = [saveData];
    const response = await APIRequest(`/${TARGET_YEAR_API}/S2Save`, { formData });
    return response;
  },
);

// AI 파싱 데이터 조회
export const getAIParseData = createAsyncThunk(
  'previousEmployment/getAIParseData',
  async () => {
    const response = await APIRequest('/YA/getAIParseData', { htmItemType: '8' });
    return response;
  },
);

const previousEmploymentSlice = createSlice({
  name: 'previousEmployment',
  initialState,
  reducers: {
    setSelectedPreviousEmployment: (state, action) => {
      state.selectedPreviousEmployment = action.payload;
    },
    confirmDelete: (state, action) => {
      console.log('action', action.payload);
      const { id } = action.payload;
      state.dataList = state.dataList.filter(item => item.id !== id);
    },
    resetPreviousEmployment: () => initialState,
  },
  extraReducers: builder => {
    //전직장 리스트
    builder.addCase(getPreviousEmploymentList.pending, state => {
      state.dataList = [];
      state.isRender = false;
    });
    //전직장 리스트
    builder.addCase(getPreviousEmploymentList.fulfilled, (state, action) => {
      console.log('action', action);
      const { list, rFlag, htmCertifyFlag } = action.payload;
      if (list) {
        state.dataList = list;
      }
      state.isRender = true;
    });

    //전직장 상세리스트
    builder.addCase(getPreviousEmploymentDetailList.pending, state => {
      state.detailDataList = [];
    });
    builder.addCase(getPreviousEmploymentDetailList.fulfilled, (state, action) => {
      console.log('action', action);
      const { list, rFlag, htmCertifyFlag } = action.payload;
      if (list && list.length > 0) {
        state.detailDataList = list[0];
      } else {
        state.detailDataList = [];
      }
    });

    //전직장 삭제
    builder.addCase(deletePreviousEmployment.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode && resultCode == 'OK') {
        state.reload = Math.random();
      }
    });

    //전직장 저장
    builder.addCase(savePreviousEmployment.fulfilled, (state, action) => {
      const { resultCode } = action.payload;
      if (resultCode && resultCode == 'OK') {
        state.reload = Math.random();
      }
    });
  },
});

export const { setSelectedPreviousEmployment, confirmDeletem, resetPreviousEmployment } =
  previousEmploymentSlice.actions;

export default previousEmploymentSlice.reducer;
